import "./styles.css";
import characters from "./characters.json";
import { useState } from "react";
import HeaderComponent from "./Components/Header";
import "../src/Fonts/Switzer-Variable.ttf";

export default function App() {
  const [index, setIndex] = useState(0);
  const slidesQuantity = characters.length;

  const handleRandom = () => {
    setIndex(Math.floor(Math.random() * slidesQuantity));
  };

  const keyDownHandler = (event) => {
    event.preventDefault();
    console.log(event.code);
    if (event.code === "Space") {
      handleRandom();
    }
  };

  return (
    <main
      style={{
        backgroundColor: characters[index].background,
        color: characters[index].textColor
      }}
      tabIndex={0}
      onKeyDown={keyDownHandler}
    >
      <HeaderComponent />
      <section>
        <h1> {characters[index].name} </h1>
        <div className="subheading">
          <h2> {characters[index].title} </h2>
          <h2> {characters[index].company} </h2>
        </div>
        <div className="content">
          <p> {characters[index].description} </p>
        </div>
      </section>

      <footer>
        <button onClick={handleRandom}> Shuffle </button>
      </footer>
    </main>
  );
}
